import { render } from "./studioOverview.vue?vue&type=template&id=67d64da3&scoped=true"
import script from "./studioOverview.vue?vue&type=script&lang=js"
export * from "./studioOverview.vue?vue&type=script&lang=js"

import "./studioOverview.vue?vue&type=style&index=0&id=67d64da3&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d64da3"]])

export default __exports__